import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { useFramerAnimation } from '../../hooks';

const Grid = ({
  children,
  classes,
  initialOpacity,
  initialScale,
  animateOpacity,
  animateScale,
  transitionDuration,
  transitionDelay,
  inViewConfigTriggerOnce,
  inViewConfigMargin,
  disableAnimations,
}) => {
  const { variants, controls, ref } = useFramerAnimation({
    initial: disableAnimations
      ? { opacity: 1, scale: 1 }
      : { opacity: initialOpacity, scale: initialScale },
    animate: disableAnimations
      ? { opacity: 1, scale: 1 }
      : { opacity: animateOpacity, scale: animateScale },
    transition: { duration: transitionDuration, delay: transitionDelay },
    inViewConfig: {
      once: inViewConfigTriggerOnce,
      margin: inViewConfigMargin,
    },
    disableAnimations,
  });

  return (
    <motion.div
      className={`grid grid-cols-1 ${classes}`}
      ref={ref}
      variants={variants}
      initial="initial"
      animate={controls}
      initialOpacity={initialOpacity}
      initialScale={initialScale}
      animateOpacity={animateOpacity}
      animateScale={animateScale}
      transitionDuration={transitionDuration}
      transitionDelay={transitionDelay}
      inViewConfigTriggerOnce={inViewConfigTriggerOnce}
      inViewConfigMargin={inViewConfigMargin}
      disableAnimations={disableAnimations}
    >
      {children}
    </motion.div>
  );
};

Grid.defaultProps = {
  classes: ``,
  initialOpacity: 0.1,
  initialScale: 0.8,
  animateOpacity: 1,
  animateScale: 1,
  transitionDuration: 0.5,
  transitionDelay: 0,
  inViewConfigTriggerOnce: true,
  inViewConfigMargin: `0%`,
  disableAnimations: false,
};

Grid.propTypes = {
  classes: PropTypes.string,
  children: PropTypes.node.isRequired,
  initialOpacity: PropTypes.number,
  initialScale: PropTypes.number,
  animateOpacity: PropTypes.number,
  animateScale: PropTypes.number,
  transitionDuration: PropTypes.number,
  transitionDelay: PropTypes.number,
  inViewConfigTriggerOnce: PropTypes.bool,
  inViewConfigMargin: PropTypes.string,
  disableAnimations: PropTypes.bool,
};

export { Grid };
